import React, { useState, useRef } from 'react';
import axios from 'axios';

export default function Write() {
  // 카테고리 옵션 정의
  const category1Options = [
    { value: 0, label: '서빙로봇' },
    { value: 1, label: '청소로봇' },
    { value: 2, label: '인터뷰' },  // 물류로봇 → 인터뷰로 변경
  ];

  const category2Options = [
    { value: 0, label: '식당' },
    { value: 1, label: '뷔페' },
    { value: 2, label: '카페베이커리' },
    { value: 3, label: '스크린골프' },
    { value: 4, label: '병원' },
    { value: 5, label: '호텔' },
    { value: 6, label: '기타' },
  ];

  const [formData, setFormData] = useState({
    title: '',
    content: '',
    url: '', 
    category1: 0,  // 기본값을 0으로 설정 (서빙로봇)
    category2: 0,  // 기본값을 0으로 설정 (식당)
  });

  const fileInputRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 입력 필드 변경 핸들러
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const newValue = type === 'number' || name === 'category1' || name === 'category2' 
      ? parseInt(value) : value;
    
    setFormData((prevState) => {
      const newFormData = {
        ...prevState,
        [name]: newValue,
      };
      
      // category1이 2(인터뷰)로 변경되면 category2를 0으로 고정
      if (name === 'category1' && newValue === 2) {
        newFormData.category2 = 0;
      }
      
      return newFormData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      alert('제목을 입력해주세요.');
      return;
    }

    if (!formData.content.trim()) {
      alert('내용을 입력해주세요.');
      return;
    }

    console.log('제출할 데이터:', formData);

    setIsSubmitting(true);

    try {
      const formDataForSubmit = new FormData();

      formDataForSubmit.append('title', formData.title);
      formDataForSubmit.append('content', formData.content);
      formDataForSubmit.append('url', formData.url || ''); 
      formDataForSubmit.append('category1', formData.category1);
      // 인터뷰(category1=2)일 때는 항상 category2=0으로 설정
      formDataForSubmit.append('category2', formData.category1 === 2 ? 0 : formData.category2);

      // 파일이 선택되었는지 확인하고 추가
      if (fileInputRef.current && fileInputRef.current.files[0]) {
        const file = fileInputRef.current.files[0];
        
        // 파일 크기 검증 (5MB 제한)
        if (file.size > 5 * 1024 * 1024) {
          alert('파일 크기는 5MB를 초과할 수 없습니다.');
          setIsSubmitting(false);
          return;
        }
        
        formDataForSubmit.append('file', file); 
        console.log('파일 추가됨:', file.name);
      }

      console.log('전송할 FormData 내용:');
      for (let pair of formDataForSubmit.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      const response = await axios.post(
        '/api/admin/insertReview',
        formDataForSubmit,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        alert('설치사례가 성공적으로 등록되었습니다.');
        window.location.href = '/admin/review';
      } else {
        alert(response.data.message || '설치사례 등록에 실패했습니다.');
      }
    } catch (error) {
      alert('오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
      console.error('폼 제출 오류:', error);
      if (error.response) {
        console.error('응답 데이터:', error.response.data);
        console.error('응답 상태:', error.response.status);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // 인터뷰가 선택되었는지 확인
  const isInterviewSelected = formData.category1 === 2;

  return (
    <>
      <div className="content-wrapper">
        <div className="titleNav">설치사례 등록</div>
        <div className="wrap">
          <div className="over_hi" style={{ marginTop: '60px' }}>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <table className="adminTable">
                <tbody>
                  <tr>
                    <th style={{ width: '200px' }}>카테고리</th>
                    <td className="left">
                      <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                        {category1Options.map((option) => (
                          <label key={option.value} style={{ marginRight: '20px' }}>
                            <input
                              type="radio"
                              name="category1"
                              value={option.value}
                              checked={formData.category1 === option.value}
                              onChange={handleChange}
                              style={{ marginRight: '5px' }}
                            />
                            {option.label}
                          </label>
                        ))}
                      </div>
                    </td>
                  </tr>
                  
                  {/* 인터뷰가 선택되지 않았을 때만 업종 선택 표시 */}
                  {!isInterviewSelected && (
                    <tr>
                      <th style={{ width: '200px' }}>업종</th>
                      <td className="left">
                        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                          {category2Options.map((option) => (
                            <label key={option.value} style={{ marginRight: '20px' }}>
                              <input
                                type="radio"
                                name="category2"
                                value={option.value}
                                checked={formData.category2 === option.value}
                                onChange={handleChange}
                                style={{ marginRight: '5px' }}
                              />
                              {option.label}
                            </label>
                          ))}
                        </div>
                      </td>
                    </tr>
                  )}

                  {/* 인터뷰가 선택되었을 때 안내 메시지 표시 (선택사항) */}
                  {isInterviewSelected && (
                    <tr>
                      <th style={{ width: '200px' }}>업종</th>
                      <td className="left">
                        <div style={{ 
                          padding: '10px', 
                          backgroundColor: '#f8f9fa', 
                          border: '1px solid #dee2e6', 
                          borderRadius: '4px',
                          color: '#6c757d'
                        }}>
                          인터뷰 카테고리는 별도의 업종 분류가 없습니다.
                        </div>
                      </td>
                    </tr>
                  )}
                  
                  <tr>
                    <th style={{ width: '200px' }}>제목</th>
                    <td className="left">
                      <input
                        type="text"
                        name="title"
                        id="title"
                        value={formData.title}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                        placeholder="설치사례 제목을 입력하세요"
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>내용</th>
                    <td className="left">
                      <textarea
                        name="content"
                        id="content"
                        style={{ 
                          width: '100%', 
                          height: '300px', 
                          padding: '8px',
                          resize: 'vertical',
                          fontFamily: 'inherit'
                        }}
                        value={formData.content}
                        onChange={handleChange}
                        placeholder="설치사례 내용을 입력하세요"
                        required
                      ></textarea>
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>관련 URL</th>
                    <td className="left">
                      <input
                        type="url"
                        name="url"
                        id="url"
                        value={formData.url}
                        onChange={handleChange}
                        style={{ width: '100%', padding: '8px' }}
                        placeholder="https://example.com (선택사항)"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th style={{ width: '200px' }}>
                      첨부파일<br />(~5MB)
                    </th>
                    <td className="left">
                      <input
                        type="file"
                        name="file"
                        id="file"
                        ref={fileInputRef}
                        accept="image/*,.pdf,.doc,.docx,.hwp,.txt"
                      />
                      <small style={{ color: '#666', marginLeft: '10px' }}>
                        (최대 5MB)
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="right" style={{ marginTop: '20px' }}>
                <button
                  type="button"
                  className="common-del"
                  onClick={() => (window.location.href = '/admin/review')}
                  style={{ marginRight: '10px' }}
                >
                  목록으로
                </button>
                <button
                  type="submit"
                  className="common-del"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '등록 중...' : '등록하기'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}